import Passes from "./Passes";
import './passes.scss';

export default Passes;